export default {
  namespaced: true,
  state: {
    loading: false,
    loadingCarrinho: false,
    isCadastroView: true,
    isLoginView: false
  },
  getters: {},
  mutations: {
    loginView (state, payload) {
      state.isLoginView = payload
    },
    cadastroView (state, payload) {
      state.isCadastroView = payload
    },
    loading (state, payload) {
      state.loading = payload
    },
    loadingCarrinho (state, payload) {
      state.loading = payload
    }
  },
  actions: {
    cadastroView ({ commit }, payload) {
      commit('cadastroView', payload)
    },
    loginView ({ commit }, payload) {
      commit('loginView', payload)
    },
    loading ({commit}, payload) {
      commit('loading', payload)
    },
    loadingCarrinho ({commit}, payload) {
      commit('loadingCarrinho', payload)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/configuracoes.js